import React from 'react'
import classes from '@src/styles/SubscriptionRequestModal.module.css'
import Dialog from '@src/components/dialog'

type ChooseQuoteModal = {
  onClose: any
  open: boolean
  message: null | "success" | "error"
  values: any;
  onChange: (ev: any) => void;
  onSubmit: () => any;
  option: any;
  submitting: boolean;
  handleBlur: any;
}

const SubscriptionRequestModal = ({ onClose, open = false, values, message, onChange, onSubmit, option, submitting, handleBlur }: ChooseQuoteModal) => {
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    onSubmit?.();
  };

  const handleReset = (event: any) => {
    event.preventDefault();
    onClose();
  }

  const fields = [
    {
      name: "name",
      type: "text",
      require: true,
      label: "What is your Name? *",
      placeholder: "ex. John Smith",
      blur: true,
    },
    {
      name: "companyName",
      type: "text",
      label: "Company Name (if business)",
      placeholder: "ex. Dimension",
      blur: true,
    },
    {
      name: "email",
      type: "email",
      label: "Contact Email *",
      require: true,
      placeholder: "ex. hello@getdimension.com",
      blur: true,
    },
    {
      name: "phone",
      type: "tel",
      label: "Contact Phone *",
      placeholder: "ex. 123-456-7890",
      require: true,
      blur: true,
    },
    {
      name: "description",
      type: "text",
      element: "textarea",
      placeholder: "Please enter any additional info that will help us provide you with the best service possible",
      label: "Additional Info (optional)"
    }
  ]

  return (
    <Dialog show={open} onHide={onClose}>
      <div className={classes.container}>
        <div>
          <h3 className={classes.h3}>Please fill out the form below and we will reach out to you within 24 hours to finalize your {option?.title} plan.</h3>
        </div>
        {message === "success" ? (
          <p className={classes.successMessage}>Thanks! A sales agent will reach out to you shortly.</p>
        ) : (
          <form onSubmit={handleSubmit} onReset={handleReset} id="request-subscription-form">
            {fields.map((field) => (
              <div className={classes.field} key={field.name}>
                <p className={classes.fieldLabel}>{field.label}</p>
                {field.element === "textarea" ? (
                  <textarea
                    name={field.name}
                    className={classes.textarea}
                    placeholder={field.placeholder}
                    onChange={onChange}
                    onBlur={field.blur ? handleBlur : undefined}
                    value={values?.[field.name]}
                    required={field.require}
                  />
                ) : (
                  <input
                    name={field.name}
                    className={classes.input}
                    placeholder={field.placeholder}
                    onChange={onChange}
                    onBlur={field.blur ? handleBlur : undefined}
                    value={values?.[field.name]}
                    type={field.type}
                    required={field.require}
                  />
                )}
              </div>
            ))}
            {message === "error" && (
              <p className={classes.errorMessage}>Please make sure the fields are filled out correctly</p>
            )}
            <div className={classes.actions}>
              <button className={classes.cancel} type="reset">Cancel</button>
              <button className={classes.submit} type="submit" disabled={submitting}>Submit</button>
            </div>
          </form>
        )}
      </div>
    </Dialog>
  )
}

export default SubscriptionRequestModal
